export enum WebSocketStatus {
  CONNECTED = 'CONNECTED',
  CONNECTING = 'CONNECTING',
  RECONNECTING = 'RECONNECTING',
  CLOSED = 'CLOSED',
}
